<template>
    <div class="bread-crumbs">
        <span
            v-for="(item, index) in breadCrumb.items"
            class="bread-crumbs__link"
        >
            <a
                v-if="index+1<breadCrumb.items.length"
                :href="item.LINK"
                :title="item.TITLE"
                itemprop="url"
            >
                {{item.TITLE}}
            </a>
        <span v-else class="bread-crumbs__link">{{item.TITLE}}</span>
        </span>
    </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
    name: "breadcrumb",
    computed: {
        ...mapState({
            breadCrumb: ({personalCabinet}) => personalCabinet.data.breadcrumb,
        })
    },
}
</script>

<style scoped>

</style>